import { useMemo } from "react";

import LinkedSidebarContent from "./LinkedSidebarContent";

import "./styles.scss";

export default function AllDetails({ detectionDetails }) {
  const { files, processes } = detectionDetails;

  // LinkedSidebarContent resets its selection whenever the sections change.
  const sections = useMemo(
    () => [
      { id: "files", title: "Files", items: files || [], titleKeyword: "file" },
      { id: "processes", title: "Processes", items: processes || [], titleKeyword: "process" },
      // { id: "hashes", title: "Hashes", items: hashes || [] },
    ],
    [files, processes],
  );

  return (
    <div>
      <LinkedSidebarContent
        sections={sections}
        defaultActiveSectionTitle="File"
        defaultActiveTabId="details"
        loading={false}
        error={false}
      />
    </div>
  );
}
